import createVueApp from '@/common/createApp'

async function mount(props) {
  const { default: GeogridViewer } = await import('@/vue_widgets/stats/geogrids/index.vue')
  createVueApp(GeogridViewer, { props })
}

async function mountCompare(props) {
  const { default: GeogridCompare } = await import('@/vue_widgets/stats/geogrids/compare/index.vue')
  createVueApp(GeogridCompare, { props })
}

Styxie.Initializers.StatsGeogrids = {
  show: mount,
  compare: mountCompare
}

Styxie.Initializers.StatsSearchTerms = {
  latest_geogrid: mount
}
